import { Link, Typography } from "@fullscript/aviary-web";
import { Trans } from "react-i18next";

import { l } from "@shared/locales/i18n";

import * as styles from "./FooterPrivacy.styles";

const FooterPrivacy = ({ ...rest }) => {
  const GOOGLE_TERMS_SERVICE_URL = "https://policies.google.com/terms";
  const GOOGLE_PRIVACY_POLICY_URL = "https://policies.google.com/privacy";

  return (
    <Typography
      variant="footnote"
      customCss={styles.fullWidth}
      {...rest}
      intention="neutral"
      colorIntensity="subtle"
    >
      <Trans i18nKey={l.sharedCommon.footerTerms}>
        This page is protected by reCAPTCHA, and subject to the &nbsp;
        <Link customCss={styles.link} href={GOOGLE_PRIVACY_POLICY_URL} hideExternalIcon>
          Google Privacy Policy
        </Link>
        and &nbsp;
        <Link customCss={styles.link} href={GOOGLE_TERMS_SERVICE_URL} hideExternalIcon>
          Google Terms of Service
        </Link>
      </Trans>
    </Typography>
  );
};

export { FooterPrivacy };
